export const withNbsp = (str: string | null | undefined) => {
  if (!str) return '';
  return str.replace(/&nbsp;/g, '\u00A0');
};
